import { attr } from '@ember-data/model';
import Enum from '@square/dashboard-utilities/utils/enum';
import { CatalogServiceChargeType, CatalogServiceChargeCalculationPhase, CatalogServiceChargeCalculationType, CatalogServiceChargeTreatmentType } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import EmberDataBaseModel from '@square/dashboard-data/models/ember-data-base-model';
import { fragment } from 'ember-data-model-fragments/attributes';
const TYPE = new Enum(['AUTO_GRATUITY', 'CUSTOM', 'CARD_SURCHARGE']);
const CALCULATION_PHASE = new Enum(['SURCHARGE_PHASE', 'SURCHARGE_TOTAL_PHASE', 'SURCHARGE_APPORTIONED_PHASE', 'CARD_SURCHARGE_PHASE']);
const CALCULATION_TYPE = new Enum(['SURCHARGE_FIXED', 'SURCHARGE_VARIABLE_PERCENTAGE', 'SURCHARGE_VARIABLE_AMOUNT']);
const TREATMENT_TYPE = new Enum(['SURCHARGE_TREATMENT_LINE_ITEM', 'SURCHARGE_TREATMENT_APPORTIONED']);
export default EmberDataBaseModel.extend({
  name: attr('string'),
  percentage: attr('string'),
  amountMoney: fragment('price-money'),
  taxable: attr('boolean'),
  type: attr('enum', {
    enumClass: TYPE,
    protoEnum: CatalogServiceChargeType
  }),
  calculationPhase: attr('enum', {
    enumClass: CALCULATION_PHASE,
    protoEnum: CatalogServiceChargeCalculationPhase
  }),
  calculationType: attr('enum', {
    enumClass: CALCULATION_TYPE,
    protoEnum: CatalogServiceChargeCalculationType
  }),
  treatmentType: attr('enum', {
    enumClass: TREATMENT_TYPE,
    protoEnum: CatalogServiceChargeTreatmentType
  })
});